const CurriculumSocialBox = () => {
  return <div>Hello World from CurriculumSocialBox</div>;
};

export default CurriculumSocialBox;
